import React from "react"
import lodash from "lodash"

const Context = React.createContext({
  openColi: lodash.noop,
  openOrder: lodash.noop,
  openStop: lodash.noop,
  openAddress: lodash.noop,
  collapseState: {}
})

export default Context
